import React, { useId } from 'react';
import styled from 'styled-components';
import Tooltip from 'components/controls/Tooltip';

type Props = React.PropsWithChildren<{
  heading?: string;
  icon: any;
  content: string;
  dropRight?: boolean;
}>;

function DropDown({ heading, icon, children, content, dropRight }: Props) {
  const iconId = useId();
  const [showDropDown, setShowDropDown] = React.useState<boolean>(false);
  const node = React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const handleClickOutside = (e: any) => {
    if (node.current.contains(e.target)) {
      return;
    }
    setShowDropDown(false);
  };

  React.useEffect(() => {
    if (showDropDown) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <Profile ref={node} style={{ cursor: 'pointer' }} onClick={() => setShowDropDown(true)}>
      <Image id={iconId} alt="" src={icon} />
      {content && (
        <Tooltip targetId={iconId} position="title">
          {content}
        </Tooltip>
      )}
      {showDropDown && (
        <ProfileDrop style={{ right: dropRight ? 'initial' : 0, left: dropRight ? 0 : 'initial' }}>
          <DropDownHeading>{heading}</DropDownHeading>
          {children}
        </ProfileDrop>
      )}
    </Profile>
  );
}

const Image = styled.img`
  height: 1rem;
  vertical-align: top;
  cursor: pointer;
  &:hover {
    & + * {
      display: initial;
    }
  }
`;

const Profile = styled.div`
  float: right;
  display: flex;
  border-radius: 50%;
  padding: 0.5rem;
  aspect-ratio: 1 / 1;
  margin: 0 0 0 1rem;
  background-color: ${(props) => props.theme.colors.gray};
  position: relative;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.darkGray};
  }
`;

export const ProfileDrop = styled.div<{ dropRight?: boolean }>`
  position: absolute;
  ${({ dropRight }) => (dropRight ? 'left: 0;' : 'right: 0;')}
  background-color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 5px 20px -5px rgba(0, 0, 0, 0.3);
  top: 2rem;
  z-index: 1;
  cursor: default;
`;

const DropDownHeading = styled.h4`
  padding: 1rem;
  margin: 0px;
  border-bottom: solid 2px ${(props) => props.theme.colors.regionColorLight};
`;

export default DropDown;
